<template>
  <v-card class="py-4 px-2">
    <v-row row-gutters class="">
      <v-col cols="12" lg="4" xs="12">
        <v-btn
          depressed
          @click="downloadExcelsheet"
          color="primary"
          small
          class="ms-2 mt-5"
          ><v-icon small>mdi-file-excel-outline</v-icon>Export
        </v-btn>
      </v-col>
      <v-col cols="12" lg="4" xs="12"></v-col>
      <v-col cols="12" lg="4" xs="12">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Type here to filter the table data."
          single-line
          hide-details
          dense
          clearable
        ></v-text-field>
      </v-col>
    </v-row>
    <loading
      :active="isloadagents"
      :is-full-page="false"
      :opacity="0.7"
      color="#ff6b00"
    />
    <v-data-table fixed-header  height="55vh"
      :headers="headers"
      :items="transactionList"
      :items-per-page="10"
      :search="search"
      :single-expand="singleExpand"
      @item-expanded="loadDetails"
      :loading="isLoading"
      loading-text="Loading... Please wait"
      item-key="id"
      show-expand
      dense
      class="mt-10"
    >
      <template v-slot:item.status="{ item }">
        {{ item.status }}
      </template>
      <template v-slot:item.countrydata="{ item }">
        <div class="d-flex justify-content-start mb-2">
          <span>
            <country-flag
              :country="item.country_code"
              style="margin-top: 1px"
            />
          </span>
          <span class="ml-3 mt-2">
            {{ item.country }}
          </span>
        </div>
      </template>

      <template v-slot:expanded-item="{ headers }">
        <td :colspan="headers.length">
          <TransactionData :trans-data="transactionDetails" />
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import Loading from "vue-loading-overlay";
import TransactionData from "../tabs/transhistoryexpand/TransactionData.vue";
import paymentService from "@/services/PaymentService/paymentService.js";
export default {
  name: "TransactionHistory",
  props: {
    selectedRemitee: {
      // type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      headers: [
        { text: "Transaction Id", value: "transaction_id" },
        { text: "Beneficiary name", value: "beneficiary_name" },
        { text: "Transaction Date", value: "send_date" },
        { text: "Beneficiary country", value: "countrydata", align: "start" },
        { text: "Transaction status", value: "status" },
        { text: "Payment Mode", value: "mode_of_payment" },
        { text: "Payout Amount", value: "amount_sent" },
        { text: "Collected Amount", value: "receiving_amount" },
        { text: "", value: "data-table-expand" },
      ],
      transactionList: [],
      search: "",
      expanded: [],
      singleExpand: true,
      isLoading: false,
      isloadagents: false,
      searchInputs: {
        transactiondate: new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10),
      },
      transactionDetails: [],
      transactionid: [],
    };
  },
  mounted() {
    console.log("datatransaction", this.selectedRemitee);
    this.getTransaction(this.selectedRemitee);
  },
  components: {
    TransactionData,
    Loading,
  },
  watch: {
    selectedRemitee(newVal) {
      this.getTransaction(newVal.login_id);
      console.log(newVal, "newVal");
    },
  },
  methods: {
    async downloadExcelsheet() {
      if (this.transactionList) {
        this.exportToExcel(this.headers, this.transactionList, "Transactions");
      }
    },
    loadDetails(item) {
      console.log(item.item.id);
      this.getTransactionByID(item.item.id);
    },
    async getTransaction(id) {
      this.isLoading = true;
      try {
        const responseData = await paymentService.getRecentTransition(id);
        if (responseData && responseData.data.status_code === 200) {
          this.transactionList = responseData.data.data;
          this.isLoading = false;
        } else {
          this.isLoading = false;
        }
        console.log("transactionList", this.transactionList);
        console.log("response", responseData);
      } catch (e) {
        this.isLoading = false;
        console.error(e);
      }
    },
    async getTransactionByID(transID) {
      this.isLoading = true;
      try {
        const responseData = await paymentService.getTransitionById(
          transID,
          this.selectedRemitee
        );
        if (responseData && responseData.data.status_code === 200) {
          this.transactionDetails = responseData.data.data;
          this.isLoading = false;
        } else {
          this.isLoading = false;
        }
        console.log("transaction", this.transactionDetails);
      } catch (e) {
        this.isLoading = false;
        console.error(e);
      }
    },
    add(val) {
      console.log(val, "val");
    },
  },
};
</script>
